// extracted by mini-css-extract-plugin
export default {"backdrop":"backdrop--YSIfs","modal":"modal--Mn3Ir","js-has-pseudo":"js-has-pseudo--IUAj3","modal-target":"modal-target--gdrqE"};